module.exports = __webpack_public_path__ + "img/p16.96f51b0c.png";